import { SuperDate } from '@razlet/utils';

export default class RaidPreliminaryInforming {
  data = null;

  scheduledAt = null;

  preDecisionAt = null;
  finalDecisionAt = null;

  constructor (data) {
    this.data = data;

    if (data.scheduledAt) this.scheduledAt = new SuperDate(data.scheduledAt);

    if (data.decisionPreTime) this.preDecisionAt = new SuperDate(data.decisionPreTime);
    if (data.decisionFinTime) this.finalDecisionAt = new SuperDate(data.decisionFinTime);
  }

  get status () {
    return this.data.status;
  }

  get statusNumber () {
    return this.data.processStatus;
  }

  get secondaryStatusNumber () {
    return this.data.processState;
  }

  get number () {
    return this.data.number;
  }

  get scheduledAt () {
    return this.scheduledAt;
  }

  get preDecisionAt () {
    return this.preDecisionAt;
  }

  get finalDecisionAt () {
    return this.finalDecisionAt;
  }

  get isScheduled () {
    return !!this.scheduledAt;
  }

  get isNotActive () {
    return !this.statusNumber || this.statusNumber === 0;
  }

  get customsInfo () {
    return this.data.customs;
  }

  get country () {
    return this.customsInfo?.country;
  }

  get side () {
    return this.customsInfo?.side;
  }

  get isDeparture () {
    return this.side === 'departure';
  }

  get isError () {
    return this.statusNumber === 2 &&
      (this.secondaryStatusNumber === 1 || this.secondaryStatusNumber === 2);
  }

  get isSuccess () {
    return this.statusNumber === 3 && this.secondaryStatusNumber === 0;
  }

  get hasInfo () {
    // eslint-disable-next-line vue/max-len
    return !!(this.number || this.scheduledAt || this.preDecisionAt || this.finalDecisionAt || this.side || this.status);
  }
};
